import React from "react";
import { EnhancedEventDetectionContext } from "./context";

export const useEnhancedEventDetectionContextProvider = () => {
  const context = React.useContext(EnhancedEventDetectionContext);
  return context;
};
